var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-card-text',{staticStyle:{"padding":"0px"}},[_c('MutationForm',{attrs:{"no-reset":"","mutation":"createRole","constants":{ environmentId: _vm.environmentId },"submitButtonText":_vm.$t('roles_create.submitButtonText'),"submitButtonIcon":"add","submit-button-color":_vm.accentColor,"schema":{
        environmentId: {
          __graphQLType: 'ID'
        },
        name: {
          label: _vm.$t('roles_create.schema.name.label'),
          type: 'string',
          description: _vm.$t('roles_create.schema.name.description'),
          fieldOptions: {
            color: _vm.accentColor,
            placeholder: _vm.$t('roles_create.schema.name.placeholder')
          },
          newDesign: true
        }
      }},on:{"success":function($event){return _vm.$emit('create', $event)},"error":function($event){return _vm.$emit('error', $event)}}},[_c('v-btn',{staticStyle:{"border":"2px solid var(--v-primary-base)"},attrs:{"slot":"left-buttons","outlined":""},on:{"click":function($event){return _vm.$emit('dismiss')}},slot:"left-buttons"},[_vm._v(_vm._s(_vm.$t('roles_create.cancelBtn')))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }